import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=10df79ae"
import script from "./Audio.vue?vue&type=script&lang=js"
export * from "./Audio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10df79ae')) {
      api.createRecord('10df79ae', component.options)
    } else {
      api.reload('10df79ae', component.options)
    }
    module.hot.accept("./Audio.vue?vue&type=template&id=10df79ae", function () {
      api.rerender('10df79ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Audio.vue"
export default component.exports